_ = require("lodash")

class TimeSeriesDataCtrl
  constructor: (@$scope, @TimeSeriesAnalysisService) ->
    @scoreData =
      categories: []
      series: []

    @$scope.$on 'filteredScorecardsUpdated.gnp.analysis', (event, timeseries) =>
      @scoreData =
        categories: @TimeSeriesAnalysisService.convertToCategories(timeseries)
        series: @TimeSeriesAnalysisService.convertToSeries(timeseries)

    @$scope.$on 'selectedCourseUpdated.gnp.analysis', (event, course) =>
      @course = course

TimeSeriesDataCtrl.$inject = [
  '$scope'
  'TimeSeriesAnalysisService'
]

module.exports = TimeSeriesDataCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis/time-series-data/time-series-data-controller.coffee